import React from 'react';
import { Coins, Users, Diamond, GitBranch } from 'lucide-react';

const InvestmentBenefits = () => {
  const benefits = [
    {
      icon: <Coins size={20} />,
      title: '10% Token Cashback',
      description: 'Receive 10% of your investment in CRYPTO tokens'
    },
    {
      icon: <Users size={20} />,
      title: '6-Level Referral System',
      description: 'Earn from your direct and indirect referrals up to 6 levels'
    },
    {
      icon: <Diamond size={20} />,
      title: 'Royalty Pool',
      description: 'Qualify for the royalty pool by meeting requirements'
    },
    {
      icon: <GitBranch size={20} />,
      title: 'Binary Matrix',
      description: 'Benefit from the spillover effect in our matrix system'
    }
  ];

  return (
    <div className="investment-benefits">
      <h2>Benefits</h2>
      <ul className="benefits-list">
        {benefits.map((benefit, index) => (
          <li key={index}>
            <div className="benefit-icon">{benefit.icon}</div>
            <div className="benefit-details">
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default InvestmentBenefits;
